var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5905C15 15.8184 15.4602 15.1351 16.0867 14.6838C17.8512 13.4129 19 11.3406 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 11.3406 6.14878 13.4129 7.91327 14.6838C8.53977 15.1351 9 15.8184 9 16.5905V17C9 17.5523 9.44772 18 10 18H14C14.5523 18 15 17.5523 15 17V16.5905ZM13.124 9.91603L11.9014 11.75H13.5C13.7766 11.75 14.0307 11.9022 14.1613 12.1461C14.2918 12.39 14.2775 12.6859 14.124 12.916L12.124 15.916C11.8943 16.2607 11.4286 16.3538 11.084 16.124C10.7393 15.8943 10.6462 15.4286 10.876 15.084L12.0986 13.25H10.5C10.2234 13.25 9.96926 13.0978 9.83874 12.8539C9.70823 12.61 9.72253 12.3141 9.87596 12.084L11.876 9.08397C12.1057 8.73933 12.5714 8.6462 12.916 8.87596C13.2607 9.10573 13.3538 9.57138 13.124 9.91603Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 19.5C9.25 19.0858 9.58579 18.75 10 18.75H14C14.4142 18.75 14.75 19.0858 14.75 19.5C14.75 19.9142 14.4142 20.25 14 20.25H10C9.58579 20.25 9.25 19.9142 9.25 19.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 22C10.25 21.5858 10.5858 21.25 11 21.25H13C13.4142 21.25 13.75 21.5858 13.75 22C13.75 22.4142 13.4142 22.75 13 22.75H11C10.5858 22.75 10.25 22.4142 10.25 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbAlt);
export default __webpack_public_path__ + "static/media/bulb-alt.1638c7cfc02409223fd2a8737159eebe.svg";
export { ForwardRef as ReactComponent };